"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { WorkspaceElementType } from '@integration-app/sdk';
import { useElement } from '../useElement.mjs';

function useScreen(selector) {
  const { item: screen, ...rest } = useElement(
    WorkspaceElementType.Screen,
    selector,
    (integrationApp) => selector ? integrationApp.screen(selector) : void 0
  );
  return { screen, ...rest };
}

export { useScreen };
